import FileSaver from "file-saver";

const convertToBlob = async (data) => {
  if (data instanceof Blob) {
    return data;
  } else if (data instanceof Response) {
    return await data.blob();
  } else if (typeof data === "string") {
    return isValidBase64String(data)
      ? new Blob([Buffer.from(data, "base64")])
      : new Blob([data]);
  }
  return null;
};

export const saveFile = async (data, filename) => {
  const blob = await convertToBlob(data);
  if (!blob) {
    console.warn(`Unable to download ${filename} (file type not supported)`);
    return null;
  }
  FileSaver.saveAs(blob, filename);
};

const base64Pattern =
  "^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$";

const isValidBase64String = (data) =>
  typeof data === "string" ? data.match(base64Pattern) : false;
